import { z } from 'zod'

export const PatientSelectiveness = z.enum(['YES', 'NO'])
export type PatientSelectiveness = z.infer<typeof PatientSelectiveness>
